<template>
  <div class="card-area">
    <form novalidate class="md-layout">
      <md-card class="md-layout-item md-size-50 md-small-size-100">
        <div class="md-title">Secure ID Verify</div>

        <md-card-header>
          <div class="md-title">Step1 of 4</div>
        </md-card-header>
        <div class="md-title">Please confirm the following:</div>
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="value">
              <label for="first-name">First Name: {{ firstName }}</label>
            </div>

            <div class="md-layout-item md-small-size-100">
              <div class="value">
                <label for="first-name">Last Name: {{ lastName }}</label>
              </div>
            </div>
          </div>

          <div>
            <div class="value">
              <label for="first-name">Date: {{ selectedDate }}</label>
            </div>
          </div>
          <div>
            <div class="value">
              <label for="first-name">phoneNumber: {{ phoneNumber }}</label>
            </div>
          </div>
        </md-card-content>

        <md-card-actions>
          <md-button class="md-primary" @click="goBack"> Change</md-button>
          <md-button class="md-primary" @click="goSend">Next</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "ConfirmUserData",
  props: {
    msg: String,
  },
  component: {},
  mixins: [validationMixin],
  data: () => ({
    firstName: "victor",
    lastName: null,
    userSaved: false,
    sending: false,
    lastUser: null,
    phoneNumber: null,
    selectedDate: null,
  }),
  validations: {
    form: {
      firstName: {
        required,
        minLength: minLength(3),
      },
      lastName: {
        required,
        minLength: minLength(3),
      },
    },
  },
  mounted() {
    this.firstName = this.$route.params.firstName;
    this.lastName = this.$route.params.lastName;
    this.selectedDate = this.$route.params.date;
    this.phoneNumber = this.$route.params.phoneNumber;
    console.log(this.selectedDate);
  },
  methods: {
    goBack() {
      //   this.$router.push({ name: "About", params: { userId: "123" } });
      this.$router.push({
        name: "InputUserData",
        params: {
          firstName: this.firstName,
          lastName: this.lastName,
          date: this.selectedDate,
          phoneNumber: this.phoneNumber,
        },
      });
    },
    goSend() {
      this.$router.push({
        name: "SendCode",
        params: {
          firstName: this.firstName,
          lastName: this.lastName,
          date: this.selectedDate,
          phoneNumber: this.phoneNumber,
        },
      });
    },
  },
};
</script>

<style lang="css" scoped>
/* .md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.md-card-actions {
  flex-direction: column;
  display: block;
}
.md-card-actions .md-button {
  margin-top: 20px !important;
  padding: 10px;
}
.md-card {
  display: inline-block;
  padding: 20px;
}
.card-area {
  align-items: center;
  justify-content: center;
  background: #ddd;
}
.md-primary {
  background-color: green;
  color: white !important;
}
.md-layout-item.md-size-50 {
  min-width: 100%;
  max-width: 50%;
} */
</style>